import { useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSButton from "../../Components/Button/WSButton";
import { useForm } from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSDateField from "../../Components/DateField/WSDateField";

interface CreateFabCardModalProps {
  open: boolean;
  onClose: () => void;
  handleCreate: (data: any) => void;
}

const CreateFabCard: React.FC<CreateFabCardModalProps> = ({
  open,
  onClose,
  handleCreate
}) => {
  const [customerId, setCustomerId] = useState("");
  const [initialPoints, setInitialPoints] = useState(0);
  const { control, handleSubmit } = useForm();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Create FAB Credit Card</DialogTitle>
      <DialogContent>
        <WSTextField
          id="customer-id"
          label="Customer ID"
          name="customer"
          control={control}
          rules={{ required: "Customer ID is required" }}
          sx={{ mb: 2 }}
        />

        <WSDateField
          id="date"
          label="Date"
          name="date"
          control={control}
          rules={{ required: "Date is required" }}
        />

        <WSTextField
          id="fab-points"
          label="Initial FAB Points"
          name="points"
          control={control}
          rules={{ required: "Initial points are required" }}
          sx={{ mb: 2, mt: 2 }}
        />

        <WSSelectField
          id="status"
          label="Status"
          name="status"
          control={control}
          options={[
            { value: "pending", label: "Pending" },
            { value: "paid", label: "Paid" }
          ]}
          rules={{ required: "Status is required" }}
        />
      </DialogContent>
      <DialogActions>
        <WSButton
          id="cancel"
          variant="contained"
          onClick={onClose}
          label="Cancel"
          className="ws-cancel"
        />
        <WSButton
          id="submit"
          variant="contained"
          onClick={handleSubmit(handleCreate)}
          label="Create Card"
        />
      </DialogActions>
    </Dialog>
  );
};

export default CreateFabCard;
